import React from 'react';
import cn from 'classnames';

import CN from './Video.module.scss';

// TODO: add custom click and play video in a modal
const Video = ({ src, title, variant, ...extra }) => (
  <iframe
    {...extra}
    data-bem="Video"
    className={cn({
      [CN.component]: true,
      [CN[`${variant}Variant`]]: variant,
    })}
    src={src}
    title={title}
    frameBorder="0"
    allow="autoplay; fullscreen; picture-in-picture"
    allowFullScreen
  />
);

export default Video;
